<template>
	<div>
		<div id='mt-swipe'>
		<mt-swipe :auto='3000'>
		  <mt-swipe-item v-for="item in imgUrls">
				<img :src="item" class="banner-image" />
		  </mt-swipe-item>
	  </mt-swipe>
		</div>
	  <div class='button-container'>
		<div id='button' @click="goBack">
		  <img src="../assets/tutorial_btn_photo.png" id='photo-icon'/><span>我知道了，去拍证件照</span>
		</div>
	  </div>
  </div>
</template>

<script>
export default {
		data() {
			return {
					imgUrls: [
              'https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_guide_six/long_pic/tutorial_step_one@3x.png',
              'https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_guide_six/long_pic/tutorial_step_two@3x.png',
              'https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_guide_six/long_pic/tutorial_step_three@3x.png',
              'https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_guide_six/long_pic/tutorial_step_four@3x.png',
              'https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_guide_six/long_pic/tutorial_step_five@3x.png'
          ],
			};
		},
		methods: {
			goBack(){
				this.$router.go(-1);
			}
		}
}
</script>

<style>
#mt-swipe{
	height: 154.67vw;
	width: 100vw;
}
.banner-image{
	height: 100%;
	width: 100%;
}
#button{
  width:94.667vw;
  height:45px;
  background:rgba(68,128,231,1);
  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
  border-radius:22.5px;
  line-height:45px;
  color: white;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-left:2.6667vw;
  margin-top: 2.1333vw;
}
#photo-icon{
  width: 19px;
  height: 16px;
  margin-left: 90px;
  margin-right: 13px; 
}
</style>
